import { Stack, Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { useRedirectModalState } from '@flows/private/movements/pages/MovementByScreenNew/hooks';

import { RedirectBox } from './styles';
import type { RedirectItemProps } from './types';

export function RedirectItem({
  title,
  description,
  id,
  handleCloseModal,
}: Readonly<RedirectItemProps>) {
  const { changeRedirectModalStateData, toggleRedirectModal } =
    useRedirectModalState();

  const toggleModal = () => {
    changeRedirectModalStateData({
      title,
      redirectEnum: id,
    });

    toggleRedirectModal();

    handleCloseModal();
  };

  return (
    <RedirectBox onClick={toggleModal}>
      <Stack gap={0.5} maxWidth="518px">
        <Typography variant="body1" fontWeight={600} textAlign="left">
          {title}
        </Typography>
        <Typography variant="body2" fontWeight={400} textAlign="left">
          {description}
        </Typography>
      </Stack>
      <Stack>
        <Icon
          color={NEW_COLORS.PRIMARY[500]}
          name="actions-b2b-open-in-new"
          size={24}
        />
      </Stack>
    </RedirectBox>
  );
}
